import _ from 'lodash'

import { BasicListInitialState, getBasicListInitialState, getBasicListReducers } from 'utils/reducer'

import {
  CLEAR_ADMINISTRATIONS,
  LIST_ADMINISTRATIONS,
  LIST_ADMINISTRATIONS_FAILED,
  LIST_ADMINISTRATIONS_SUCCESS,
  UPDATE_ADMINISTRATION_ITEM,
} from './constants'
import { Administration, EmergencyDose } from '../models'

export interface AdministrationsListState extends BasicListInitialState {
  data: (Administration & EmergencyDose)[]
}

const initialState = getBasicListInitialState

export default (...props) => {
  const [state = initialState, { payload, type }] = props

  const basicListReducer = getBasicListReducers({
    clear: CLEAR_ADMINISTRATIONS,
    failed: LIST_ADMINISTRATIONS_FAILED,
    init: LIST_ADMINISTRATIONS,
    success: LIST_ADMINISTRATIONS_SUCCESS,
  }, initialState, props)

  if (null !== basicListReducer) {
    return basicListReducer
  }

  if (UPDATE_ADMINISTRATION_ITEM === type) {
    return {
      ...state,
      data: _.map(state.data, (item) => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      }),
    }
  }

  return state
}

